import { graphqlPost } from "api/graphqlClient";
import NotificationService from "components/Notification/Notification.service";
import RestErrorNotification from "components/Notification/RestErrorNotification";
import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { actions } from "./IdentityRole.reducer";

/**
 * Create identity<>role association
 */
export function* createIdentityRole({ promise, params }) {
    try {
        const apiResult = yield graphqlPost(params);
        yield put({
            type: actions.CREATE_IDENTITYROLE_SUCCESSFUL,
        });
        yield call(promise.resolve, apiResult);
    } catch (error) {
        yield put({
            type: actions.CREATE_IDENTITYROLE_FAILED,
        });
        NotificationService.error(<RestErrorNotification error={error} />);
        yield call(promise.reject, error?.response?.data || error);
    }
}

/**
 * Delete identity<>role association
 */
export function* deleteIdentityRole({ promise, params, silent }) {
    try {
        const apiResult = yield graphqlPost(params);
        yield put({
            type: actions.DELETE_IDENTITYROLE_SUCCESSFUL,
        });
        yield call(promise.resolve, apiResult);
    } catch (error) {
        yield put({
            type: actions.DELETE_IDENTITYROLE_FAILED,
        });
        // In a bulk removal the caller aggregates per-item outcomes into a single
        // summary notification, so it dispatches with `silent` to avoid one raw
        // error toast per failed item. Single (non-bulk) removals still toast.
        if (!silent) {
            NotificationService.error(<RestErrorNotification error={error} />);
        }
        yield call(promise.reject, error?.response?.data || error);
    }
}

/**
 * Update identity<>role association
 */
export function* updateIdentityRole({ promise, params }) {
    try {
        const apiResult = yield graphqlPost(params);
        yield put({
            type: actions.UPDATE_IDENTITYROLE_SUCCESSFUL,
        });
        yield call(promise.resolve, apiResult);
    } catch (error) {
        yield put({
            type: actions.UPDATE_IDENTITYROLE_FAILED,
        });
        NotificationService.error(<RestErrorNotification error={error} />);
        yield call(promise.reject, error?.response?.data || error);
    }
}

function* fetchIdentityRoleList({ promise, iri, params }) {
    try {
        const apiResult = yield graphqlPost(params);
        yield put({
            type: actions.FETCH_IDENTITYROLE_LIST_SUCCESSFUL,
            iri,
            response: apiResult?.data,
        });
        yield call(promise.resolve, apiResult);
    } catch (error) {
        yield put({
            type: actions.FETCH_IDENTITYROLE_LIST_FAILED,
        });
        NotificationService.error(<RestErrorNotification error={error} />);
        yield call(promise.reject, error?.response?.data || error);
    }
}

function* fetchIdentityRoleListInitialCount({ promise, iri, params }) {
    try {
        const apiResult = yield graphqlPost(params);
        yield put({
            type: actions.FETCH_IDENTITYROLE_LIST_INITIAL_COUNT_SUCCESSFUL,
            iri,
            response: apiResult?.data,
        });
        yield call(promise.resolve, apiResult);
    } catch (error) {
        yield put({
            type: actions.FETCH_IDENTITYROLE_LIST_INITIAL_COUNT_FAILED,
        });
        yield call(promise.reject, error?.response?.data || error);
    }
}

/**
 * Register action to watcher
 */
export default [
    // takeEvery (NOT takeLatest) for these promise-bridged mutation sagas: each
    // dispatch carries its own promise resolver, and a bulk action fires several
    // in the same tick via runWithConcurrency. takeLatest would cancel the
    // earlier saga tasks, so their promises would never settle -> the bulk
    // Promise.all hangs, the progress bar stays stuck and the action button
    // spins forever (the "Remove from role" meltdown).
    takeEvery(actions.START_CREATE_IDENTITYROLE, createIdentityRole),
    takeEvery(actions.START_DELETE_IDENTITYROLE, deleteIdentityRole),
    takeEvery(actions.START_UPDATE_IDENTITYROLE, updateIdentityRole),
    takeLatest(actions.START_FETCH_IDENTITYROLE_LIST, fetchIdentityRoleList),
    takeLatest(
        actions.START_FETCH_IDENTITYROLE_LIST_INITIAL_COUNT,
        fetchIdentityRoleListInitialCount
    ),
];
